import { makeStyles } from '@material-ui/core';

export const getProposalPreviewDefaultEnvironmentalImpactStyles = makeStyles(
  () => ({
    negativeImpactTable: {
      paddingTop: '12mm',
    },
  }),
);
